@import 'apps/webcomponents/src/assets/common.scss';

.section-title {

  height: calc(4 * var(--spacer));
  line-height: 1.5;
  padding: var(--spacer) 0;
}

.wrapper {
  height: auto;
}

.content {
  margin-top: var(--spacer);
  gz-labeled-content {
    &::part(label) {
      font-size: var(--body-size);
    }
    &::part(content) {
      font-size: var(--body-size);
    }
  }
  gz-link {
    font-size: var(--body-size);
    &::part(container) {
      padding: 0;
    }
  }
}

gz-labeled-content[clampline] {
  gz-copy-to-clipboard {
    span {
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      word-break: break-word;
    }
  }
}

gz-copy-to-clipboard {
  span {
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.link-overflow {
  white-space: normal;
  word-break: break-word;
}

#sectionFooter {
  .action-footer-item {
    &:nth-child(even) {
      .action-footer-item {
        padding-left: calc(var(--spacer) * 2);
      }
    }
    &::part(button-text) {
      font-size: var(--small-button-font-size);
    }
    &:nth-child(odd) {
      &:after {
        content: '';
        height: 16px;
        width: 1px;
        position: absolute;
        background-color: var(--chart-101-pressed-dividers);
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto 0;
      }
    }
  }
}
